import { navLinks } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-vidicon-2-line text-xl" aria-hidden="true"></i>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-950">金桔影院</span>
                <span className="text-[10px] tracking-[0.3em] text-primary-700">JINJU CINEMA</span>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-foreground-700">
              一份专注访问体验的导读页：汇总金桔影院官网最新地址、网址与常用入口，并把“打不开怎么办”拆成可执行的步骤，帮你在最短时间里回到观影页面。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-50 text-foreground-700 transition-colors hover:text-primary-700"
                >
                  <i className={`${icon} text-base`} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">本页导读</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">访问小贴士</h3>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-base text-accent-600" aria-hidden="true"></i>
                入口以本页所列名称为准
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-base text-accent-600" aria-hidden="true"></i>
                收藏时同时保留一条备用线路
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-base text-accent-600" aria-hidden="true"></i>
                遇到弹窗密集的页面立即关闭
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-secondary-300/70 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-600">© {year} 金桔影院 · 本页为访问指引展示页，内容仅供核对参考</p>
          <p className="text-xs text-foreground-500">静态展示 · 不跳转外部页面 · 不收集任何信息</p>
        </div>
      </div>
    </footer>
  );
}